import { createFileRoute } from "@tanstack/react-router";
import { BuildVsBuyPage } from "@/components/guides/BuildVsBuyPage";
import { buildVsBuySeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/build-vs-buy-stb")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => buildVsBuySeo(loaderData?.href ?? "/guides/build-vs-buy-stb"),
  component: BuildVsBuyPage,
});
